import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_sustainable_kitchen: FaireThemeEntity = {
  token: "discovery_theme_sustainable-kitchen",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Sustainable Everyday Kitchen",
  description: "Eco-friendly essentials for the modern kitchen",
  bgColor: "#F5D6D6",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
